import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setUpdatesModalView } from 'redux/reducers/user/updatesModal';
import { RootState } from 'redux/rootReducer';
import useMedia from 'hooks/useMedia';
import { History } from 'history';

import Modal from 'components/utility/Modal/Modal';
import { ReactComponent as CloseIcon } from 'icons/icon-close-large.svg';
import Carousel from 'components/base/Carousel';
import Box from 'components/elements/Box';
import P from 'components/elements/p';

import carouselData from './data';

import { BoxWrapper, CloseButton, Content, Figure, NextButton } from './styles';

interface IUpdatesModalProps {
  history: History;
}

const UpdatesModal: React.FC<IUpdatesModalProps> = (props) => {
  const dispatch = useDispatch();
  const userSettings = useSelector(
    (state: RootState): any => state.userSettings
  );
  const [showUpdatesModal, setShowUpdatesModal] = useState(true);

  const wasShownBefore =
    userSettings?.loading?.all === false &&
    userSettings?.success?.all === true &&
    !!userSettings?.data?.updatesModalShown;
  const isMobileScreen = useMedia('(max-width: 80em)');
  if (
    wasShownBefore ||
    userSettings?.loading?.all ||
    !userSettings?.success?.all ||
    isMobileScreen
  )
    return null;

  const { history } = props;

  const CarouselNextButton =
    (handleClick: () => void) =>
    ({ onClick, text }: { onClick: any; text: string }): JSX.Element =>
      (
        <NextButton onClick={text === 'Done' ? handleClick : onClick}>
          {text}
        </NextButton>
      );

  const saveModalDisplaying = (): void => {
    dispatch(setUpdatesModalView(true));
    setShowUpdatesModal(false);
  };

  const saveDisplayingWithForward = (): void => {
    saveModalDisplaying();
    history.push('/');
  };

  return (
    <>
      {showUpdatesModal && (
        <Modal
          hide={saveModalDisplaying}
          canClickOutside
          maxWidth="78.2%"
          borderRadius="9px"
        >
          <Content>
            <CloseButton
              display="block"
              marginLeft="auto"
              onClick={saveModalDisplaying}
            >
              <CloseIcon />
            </CloseButton>

            <Carousel
              CustomizedNextButton={CarouselNextButton(
                saveDisplayingWithForward
              )}
              hasOnlyNextButton
              slidesCount={carouselData.length}
            >
              {carouselData.map((item: any, index: number): JSX.Element => {
                return (
                  <BoxWrapper display="grid" p={4} pb="0" key={index}>
                    <Box pl="4.375em" pt="1.5em">
                      <P
                        pb={5}
                        textAlign="left"
                        fontSize="1.875em"
                        fontWeight="600"
                        lineHeight="30px"
                      >
                        {item.title}
                      </P>
                      <P textAlign="left" fontSize="1.125em" lineHeight="24px">
                        {item.text}
                      </P>
                    </Box>

                    <Figure>
                      <img src={item.imageUrl} alt={`carouselImage${index}`} />
                    </Figure>
                  </BoxWrapper>
                );
              })}
            </Carousel>
          </Content>
        </Modal>
      )}
    </>
  );
};

export default UpdatesModal;
